import _ from 'lodash'
import API from '../../assets/js/libs/API'
import { SET_ADMIN_AUTH } from './mutation-types'
export default {
  fetchAdminPermission({ commit }) {
    return API.get('position/auth')
      .then((res) => res.result)
      .then((result) => {
        commit(SET_ADMIN_AUTH, result)
      })
      .catch((err) => {
        console.log(err)
      })
  },
}



// WEBPACK FOOTER //
// ./src/store/adminPermissionStore/actions.js